export enum ExaminationDiagnosisMode {
  Editable = 'editable',
  ReadOnly = 'readOnly',
  NotAvailable = 'notAvailable',
}
